import '../vendor/slick';

/**
 * Slider component
 *
 * @type {object}
 */
const slider = {

	/**
	 * Initialize.
	 *
	 * @return {void}
	 */
	init() {

		this.testimonialSlider();

		// this.mediaStorySlider();.
		this.aboutMemberSlider();

		// this.aboutLogoSlider();.
		this.impactSlider();

		//this.partnerSlider();

	},

	/**
	 * Create slider.
	 *
	 * @return {void}
	 */
	testimonialSlider: function() {
		const sliderContainer = $( '#testimonial-slider' );

		if ( ! sliderContainer.length ) {
			return;
		}

		$( '#testimonial-thumb' ).slick( {
			slidesToShow: 3,
			slidesToScroll: 1,
			asNavFor: '#testimonial-content',
			dots: false,
			arrows: true,
			centerMode: true,
			centerPadding: '0px',
			focusOnSelect: true,
			responsive: [
				{
					breakpoint: 813,
					settings: {
						slidesToShow: 1
					}
				}
			]
		} );

		$( '#testimonial-content' ).slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			fade: true,
			adaptiveHeight: true,
			asNavFor: '#testimonial-thumb'
		} );

	},

	/**
	 * Media Story Slider
	 *
	 * @return {void}
	 */
	mediaStorySlider: function() {
		const mediaStorySlider = $( '#media-story-slider' );

		if ( ! mediaStorySlider.length ) {
			return;
		}

		mediaStorySlider.slick( {
			slidesToShow: 3,
			slidesToScroll: 1,
			centerMode: true,
			centerPadding: '0px',
			arrows: true,
			dots: false,
			appendArrows: $( '.media-story-wrapper' ),
			customPaging: function ( slider, i ) {
				return $( '<button class="slick-dot-button" type="button" />' ).text( i + 1 );
			},
			responsive: [
				{
					breakpoint: 813,
					settings: {
						slidesToShow: 1
					}
				}
			]
		} );
	},

	/**
	 * About => Membre slider for Directors and Leaderships
	 *
	 * @return {void}
	 */
	aboutMemberSlider: function() {
		const memberSlider = $( '.member-3-slider' );

		if ( ! memberSlider.length ) {
			return;
		}

		memberSlider.slick( {
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			customPaging: function ( slider, i ) {
				return $( '<button class="slick-dot-button" type="button" />' ).text( i + 1 );
			},
			responsive: [
				{
					breakpoint: 813,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		} );
	},

	/**
	 * About => Investers and Partners slider
	 *
	 * @return {void}
	 */
	aboutLogoSlider: function() {
		const logoSlider = $( '.logo-slider' );

		if ( ! logoSlider.length ) {
			return;
		}

		logoSlider.slick( {
			arrows: false,
			autoplay: true,
			dots: true,
			fade: true,
			slidesToScroll: 1,
			slidesToShow: 1,
			customPaging: function ( slider, i ) {
				return $( '<button class="slick-dot-button" type="button" />' ).text( i + 1 );
			}
		} );
	},

	/**
	 * Partners slider
	 *
	 * @return {void}
	 */
	partnerSlider: function() {
		const partners = $( '#partners-slider' );

		if ( ! partners.length ) {
			return;
		}

		partners.slick( {
			arrows: false,
			autoplay: true,
			dots: true,
			slidesToScroll: 1,
			slidesToShow: 5,
			customPaging: function ( slider, i ) {
				return $( '<button class="slick-dot-button" type="button" />' ).text( i + 1 );
			},
			responsive: [
				{
					breakpoint: 813,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				}
			]
		} );
	},

	/**
	 * Impact slider
	 *
	 * @return {void}
	 */
	impactSlider: function() {
		const impactSlider = $( '.impact-slider' );

		if ( ! impactSlider.length ) {
			return;
		}

		impactSlider.slick( {
			arrows: true,
			dots: true,
			slidesToScroll: 1,
			slidesToShow: 1,
			customPaging: function ( slider, i ) {
				return $( '<button class="slick-dot-button" type="button" />' ).text( i + 1 );
			},
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: false,
						autoplay: true,
						slidesToScroll: 1,
						slidesToShow: 1
					}
				}
			]
		} );
	}

};

export { slider };
